// extracted by mini-css-extract-plugin
export default {"alert-box":"TaskRefusalController_alert-box__68zcd"};